export const blockIconsTravelAirlineSeatReclineNormalNew = (
	<span className='material-symbols-outlined'>airline_seat_recline_normal</span>
);
